import { UserManager } from "oidc-client-ts";
export const oidcConfig: any = {
  authority: '',
  client_id: '',
  redirect_uri: '',
  post_logout_redirect_uri: '',
  scope: 'openid profile groups email',
  response_type: 'code',
  automaticSilentRenew: true,
  state: true,
  revokeAccessTokenOnSignout: true,
  clearHashAfterLogin: true,
};

export let userManager: any;

export let signout_uri: any;

export const initOidcInstance = (config: any) => {
  oidcConfig.authority = config?.authority;
  oidcConfig.client_id = config?.clientId;
  oidcConfig.redirect_uri = window.location.origin;
  oidcConfig.post_logout_redirect_uri = window.location.origin;
  userManager = new UserManager(oidcConfig);
  signout_uri = config?.signoutUri;
};

export const signOut = () => {
  localStorage.clear();
  sessionStorage.clear();  
  const redirect_uri = window.location.origin;
  const signOutUrl = `${signout_uri}${encodeURIComponent(redirect_uri)}`;
  window.location.replace(signOutUrl);
};